import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import {
  Button,
  Row,
  Table,
  Input,
  Label,
  Col,
  Card,
  CardHeader,
  CardText,
  CardBody,
} from "reactstrap";
import moment from "moment";
import Swal from "sweetalert2";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import * as am5percent from "@amcharts/amcharts5/percent";

function DashboardGastos() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;
  const BANCO_EFECTIVO = process.env.REACT_APP_BANCO_EFECTIVO;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [info, setInfo] = useState([]);
  const [graficasConceptos, setGraficasConceptos] = useState([]);
  const [graficasEmpresas, setGraficasEmpresas] = useState([]);
  const [graficasMeses, setGraficasMeses] = useState([]);
  const [detalle, setDetalle] = useState([]);
  const [valorGastado, setValorGastado] = useState(0);
  const [taref, setTaref] = useState(0);

  // Los catalogos de categorias / subcategorias / solicitantes se eliminaron:
  // el dashboard se filtra por concepto, empresa y banco
  const [conceptos, setConceptos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [meses, setMeses] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedBanco, setSelectedBanco] = useState("");
  const [selectedMes, setSelectedMes] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Danos unos segundos....",
      customClass: {
        icon: "animated-icon",
      },
    });
  }

  // Un solo lugar arma la peticion y los catalogos de los filtros
  function traeInfo() {
    setCargando(true);
    axios
      .get(`${URL_DASHBOARDS}Gastos/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGastos = response.data;
        setInfo(allGastos);

        const unicos = (llave) =>
          allGastos.filter(
            (value, index, self) =>
              index === self.findIndex((t) => t[llave] === value[llave])
          );

        setConceptos(unicos("idConcepto"));
        setEmpresas(unicos("idEmpresa"));
        setBancos(unicos("idBanco"));
        setMeses(unicos("Mes"));

        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
        Toast.close();
      });
  }

  useEffect(() => {
    traeInfo();
  }, []);

  function BuscaInfo() {
    setInfo([]);
    setSelectedConcepto("");
    setSelectedEmpresa("");
    setSelectedBanco("");
    setSelectedMes("");
    traeInfo();
  }

  useMemo(() => {
    let temp = info;

    if (selectedMes) {
      temp = temp.filter((e) => e.Mes === selectedMes);
    }
    if (selectedConcepto) {
      temp = temp.filter((e) => String(e.idConcepto) === selectedConcepto);
    }
    if (selectedEmpresa) {
      temp = temp.filter((e) => String(e.idEmpresa) === selectedEmpresa);
    }
    if (selectedBanco) {
      temp = temp.filter((e) => String(e.idBanco) === selectedBanco);
    }

    const agrupa = (llaveId, llaveNombre) => {
      let agrupado = temp.reduce(function (groups, item) {
        const val = item[llaveId];
        groups[val] = groups[val] || { [llaveId]: item[llaveId], total: 0 };
        groups[val].total += parseFloat(item.total || 0);
        groups[val][llaveNombre] = item[llaveNombre];
        return groups;
      }, []);
      return Object.values(agrupado).sort((a, b) => (a.total < b.total ? 1 : -1));
    };

    setGraficasConceptos(agrupa("idConcepto", "concepto"));
    setGraficasEmpresas(agrupa("idEmpresa", "empresa"));

    let agrupadoMes = temp.reduce(function (groups, item) {
      const val = item["Mes"];
      groups[val] = groups[val] || { Mes: item.Mes, total: 0 };
      groups[val].total += parseFloat(item.total || 0);
      return groups;
    }, []);
    setGraficasMeses(
      Object.values(agrupadoMes).sort((a, b) => (a.Mes > b.Mes ? 1 : -1))
    );

    setDetalle(
      [...temp].sort((a, b) => (a.fecha > b.fecha ? 1 : -1))
    );

    let TVal = temp.map((c) => parseFloat(c.total || 0));
    setValorGastado(TVal.reduce((t, total) => t + total, 0));

    let tar = temp.filter((e) => String(e.idBanco) === BANCO_EFECTIVO);
    setTaref(tar.reduce((t, c) => t + parseFloat(c.total || 0), 0));
  }, [info, selectedMes, selectedConcepto, selectedEmpresa, selectedBanco]);

  useLayoutEffect(() => {
    // Grafica Conceptos
    let root = am5.Root.new("chartdiv");
    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        endAngle: 270,
        layout: root.verticalLayout,
        tooltip: am5.Tooltip.new(root, {
          labelText: "{concepto} {value}",
        }),
      })
    );

    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "total",
        categoryField: "concepto",
        endAngle: 270,
      })
    );

    series.states.create("hidden", { endAngle: -90 });

    chart.children.unshift(
      am5.Label.new(root, {
        text: "Conceptos",
        fontSize: 25,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0,
      })
    );

    series.labels.template.set("forceHidden", true);
    series.ticks.template.setAll({
      visible: false,
      stroke: am5.color("rgb(252, 252, 252)"),
    });
    series.data.setAll(graficasConceptos);
    series.appear(1000, 100);

    let legend = chart.children.push(
      am5.Legend.new(root, { nameField: "concepto" })
    );
    legend.data.setAll(series.dataItems);

    // Grafica Empresas
    let rootEmpresa = am5.Root.new("chartdivEmpresa");
    rootEmpresa.setThemes([am5themes_Animated.new(rootEmpresa)]);

    let chartEmpresa = rootEmpresa.container.children.push(
      am5percent.PieChart.new(rootEmpresa, {
        endAngle: 270,
        layout: rootEmpresa.verticalLayout,
        tooltip: am5.Tooltip.new(rootEmpresa, {
          labelText: "{empresa} {value}",
        }),
      })
    );

    let seriesEmpresa = chartEmpresa.series.push(
      am5percent.PieSeries.new(rootEmpresa, {
        valueField: "total",
        categoryField: "empresa",
        endAngle: 270,
      })
    );

    seriesEmpresa.states.create("hidden", { endAngle: -90 });

    chartEmpresa.children.unshift(
      am5.Label.new(rootEmpresa, {
        text: "Empresas",
        fontSize: 25,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0,
      })
    );

    seriesEmpresa.labels.template.set("forceHidden", true);
    seriesEmpresa.ticks.template.setAll({
      visible: false,
      stroke: am5.color("rgb(252, 252, 252)"),
    });
    seriesEmpresa.data.setAll(graficasEmpresas);
    seriesEmpresa.appear(1000, 100);

    let legendEmpresa = chartEmpresa.children.push(
      am5.Legend.new(rootEmpresa, { nameField: "empresa" })
    );
    legendEmpresa.data.setAll(seriesEmpresa.dataItems);

    // Gasto Mensual
    let rootMes = am5.Root.new("chartdivMes");
    rootMes.setThemes([am5themes_Animated.new(rootMes)]);

    let chartMes = rootMes.container.children.push(
      am5xy.XYChart.new(rootMes, {
        panY: false,
        layout: rootMes.verticalLayout,
      })
    );

    let dataMes = graficasMeses;

    let yAxisMes = chartMes.yAxes.push(
      am5xy.ValueAxis.new(rootMes, {
        min: 0,
        renderer: am5xy.AxisRendererY.new(rootMes, {}),
      })
    );

    let xAxisMes = chartMes.xAxes.push(
      am5xy.CategoryAxis.new(rootMes, {
        renderer: am5xy.AxisRendererX.new(rootMes, {}),
        categoryField: "Mes",
      })
    );
    xAxisMes.data.setAll(dataMes);

    let seriesMes = chartMes.series.push(
      am5xy.ColumnSeries.new(rootMes, {
        name: "Mes",
        xAxis: xAxisMes,
        yAxis: yAxisMes,
        valueYField: "total",
        categoryXField: "Mes",
        tooltip: am5.Tooltip.new(rootMes, {
          labelText: "{Mes} ${valueY}",
        }),
      })
    );
    seriesMes.data.setAll(dataMes);

    chartMes.set("cursor", am5xy.XYCursor.new(rootMes, {}));

    let exportingMes = am5plugins_exporting.Exporting.new(rootMes, {
      menu: am5plugins_exporting.ExportingMenu.new(rootMes, {}),
    });

    chartMes.children.unshift(
      am5.Label.new(rootMes, {
        text: "Mensual",
        fontSize: 25,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0,
      })
    );

    return () => {
      root.dispose();
      rootMes.dispose();
      rootEmpresa.dispose();
    };
  }, [graficasConceptos, graficasMeses, graficasEmpresas]);

  const dinero = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(n || 0);

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="card container col-12">
        <Row>
          <Col md={8}>
            <Button
              size="sm"
              href="/Dashboards"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Col>
        </Row>
        <h3 align="center">Dashboard Gastos</h3>
        <Row>
          <Col md={2}>
            <Label className="mr-sm-2">Fecha Inicio</Label>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaInicio}
              required
              onChange={(e) => {
                setSelectedFechaInicio(e.target.value);
              }}
            />
          </Col>
          <Col md={2}>
            <Label className="mr-sm-2">Fecha Fin</Label>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaFin}
              required
              onChange={(e) => {
                setSelectedFechaFin(e.target.value);
              }}
            />
          </Col>
          <Col md={2}>
            <h4></h4>
            <Button
              size="sm"
              className="btn"
              id="botonListado"
              onClick={BuscaInfo}
              color="info"
            >
              Actualizar
            </Button>
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={2}>
            <Label className="mr-sm-2">Meses</Label>
            <Input
              bsSize="sm"
              type="select"
              value={selectedMes}
              required
              onChange={(e) => {
                setSelectedMes(e.target.value);
              }}
            >
              <option value="">Selecciona</option>
              {meses
                .sort((a, b) => (a.Mes > b.Mes ? 1 : -1))
                .map((a) => {
                  return (
                    <option key={a.Mes} value={a.Mes}>
                      {a.Mes}
                    </option>
                  );
                })}
            </Input>
          </Col>

          <Col md={2}>
            <Label className="mr-sm-2">Concepto</Label>
            <Input
              bsSize="sm"
              type="select"
              value={selectedConcepto}
              required
              onChange={(e) => {
                setSelectedConcepto(e.target.value);
              }}
            >
              <option value="">Selecciona</option>
              {conceptos
                .sort((a, b) => (a.concepto > b.concepto ? 1 : -1))
                .map((a) => {
                  return (
                    <option key={a.idConcepto} value={a.idConcepto}>
                      {a.concepto}
                    </option>
                  );
                })}
            </Input>
          </Col>

          <Col md={2}>
            <Label className="mr-sm-2">Empresa</Label>
            <Input
              bsSize="sm"
              type="select"
              value={selectedEmpresa}
              required
              onChange={(e) => {
                setSelectedEmpresa(e.target.value);
              }}
            >
              <option value="">Selecciona</option>
              {empresas
                .sort((a, b) => (a.empresa > b.empresa ? 1 : -1))
                .map((a) => {
                  return (
                    <option key={a.idEmpresa} value={a.idEmpresa}>
                      {a.empresa}
                    </option>
                  );
                })}
            </Input>
          </Col>

          <Col md={2}>
            <Label className="mr-sm-2">Banco</Label>
            <Input
              bsSize="sm"
              type="select"
              value={selectedBanco}
              required
              onChange={(e) => {
                setSelectedBanco(e.target.value);
              }}
            >
              <option value="">Selecciona</option>
              {bancos
                .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                .map((a) => {
                  return (
                    <option key={a.idBanco} value={a.idBanco}>
                      {a.banco}
                    </option>
                  );
                })}
            </Input>
          </Col>
        </Row>

        <div
          className="container"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Col md={3}>
            <Card>
              <CardHeader tag="h3" align="center">
                GASTO TOTAL
              </CardHeader>
              <CardBody>
                <CardText tag="h4" align="center">
                  {dinero(valorGastado)}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col md={3}>
            <Card>
              <CardHeader tag="h3" align="center">
                EFECTIVO
              </CardHeader>
              <CardBody>
                <CardText tag="h4" align="center">
                  {dinero(taref)}
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <div id="chartdiv" style={{ width: "40%", height: "500px" }}></div>

          <div
            id="chartdivEmpresa"
            style={{ width: "40%", height: "500px" }}
          ></div>
        </div>

        <br />
        <br />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div id="chartdivMes" style={{ width: "90%", height: "500px" }}></div>
        </div>

        <br />
        <h5 align="center">Detalle de gastos</h5>
        <Table size="sm" striped borderless responsive className="table-responsive-xl">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Empresa</th>
              <th>Concepto</th>
              <th>Descripcion</th>
              <th>Banco</th>
              <th align="right">Subtotal</th>
              <th align="right">IVA</th>
              <th align="right">Total</th>
            </tr>
          </thead>
          <tbody>
            {detalle.map((a) => (
              <tr key={a._id}>
                <td>{a.fecha}</td>
                <td>{a.empresa}</td>
                <td>{a.concepto}</td>
                <td>{a.descripcion}</td>
                <td>{a.banco}</td>
                <td align="right">{dinero(a.subtotal)}</td>
                <td align="right">{dinero(a.iva)}</td>
                <td align="right" style={{ fontWeight: 600 }}>
                  {dinero(a.total)}
                </td>
              </tr>
            ))}
            {!detalle.length ? (
              <tr>
                <td colSpan="8" style={{ color: "#94a3b8" }}>
                  Sin gastos en el periodo.
                </td>
              </tr>
            ) : null}
            {detalle.length ? (
              <tr style={{ borderTop: "1px solid #e2e8f0" }}>
                <td colSpan="7" align="right">
                  <b>Total</b>
                </td>
                <td align="right">
                  <b>{dinero(valorGastado)}</b>
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
        <br />
      </div>
    </>
  );
}
export default DashboardGastos;
